// Store loading states per element
const loadingStates = new WeakMap();

export default function (pageElement, pageNumber, scope) {
  if (!pageElement) {
    return Promise.resolve([]);
  }

  // Check if this specific element is already loading
  if (loadingStates.get(pageElement)) {
    return Promise.resolve([]);
  }

  let page = pageNumber;
  let url = `${pageElement.dataset.membersPath}?page=${page}`;
  let list_id = pageElement.dataset.list;
  let search = pageElement.value || "";
  if (list_id) {
    url += `&list_id=${list_id}`;
  }
  if (search.length > 2) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (scope) {
    url += `&scope=${scope}`;
  }

  // Set loading state for this element
  loadingStates.set(pageElement, true);

  return fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .finally(() => {
      // Reset loading state for this element
      loadingStates.set(pageElement, false);
    });
}
